import React from 'react';

const Controls = ({
  onAddItem,
  onExportPdf,
  onSaveInvoice,
  onLoadInvoice,
  onLoadInvoiceIdChange,
  loadInvoiceId,
  savedInvoices,
  onSelectSavedInvoice,
  onDeleteSavedInvoice,
}) => {
  return (
    <div className="mt-8 flex flex-col items-center w-full px-4 md:px-0 max-w-lg">
      <button
        id="add-row-btn"
        className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-full shadow-lg transition duration-300 ease-in-out"
        onClick={onAddItem}
      >
        + Add Item
      </button>
      <div className="mt-4 flex space-x-2">
        <button
          id="export-pdf-btn"
          className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full shadow-lg transition duration-300 ease-in-out"
          onClick={onExportPdf}
        >
          Export to PDF
        </button>
        <button
          id="save-btn"
          className="bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 px-4 rounded-full shadow-lg transition duration-300 ease-in-out"
          onClick={onSaveInvoice}
        >
          Save
        </button>
      </div>
      <div className="mt-4 flex items-center space-x-2 w-full">
        <input
          type="text"
          id="load-invoice-id"
          placeholder="Enter Invoice ID to load"
          className="flex-grow px-4 py-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
          value={loadInvoiceId}
          onChange={(e) => onLoadInvoiceIdChange(e.target.value)}
        />
        <button
          id="load-btn"
          className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-full shadow-lg transition duration-300 ease-in-out"
          onClick={onLoadInvoice}
        >
          Load
        </button>
      </div>

      <div className="mt-8 w-full">
        <h3 className="text-xl font-bold text-gray-700 mb-4">Your Saved Invoices</h3>
        <div id="saved-invoices-list" className="flex flex-col space-y-2">
          {savedInvoices.length === 0 ? (
            <p className="text-sm text-gray-500">No saved invoices found.</p>
          ) : (
            savedInvoices.map((invoice) => (
              <div
                key={invoice.id}
                className="flex items-center justify-between w-full p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition duration-150 ease-in-out"
              >
                <button
                  className="w-full text-left font-semibold text-gray-800 hover:text-blue-500"
                  onClick={() => onSelectSavedInvoice(invoice.id)}
                >
                  <span className="font-semibold">{invoice.invoiceNumber}</span> - <span className="text-gray-600">{invoice.company}</span> - <span className="text-gray-600">{invoice.date}</span>
                </button>
                <button
                  className="text-red-500 hover:text-red-700 font-bold ml-4 p-1 rounded-full bg-red-100 hover:bg-red-200 transition duration-150 ease-in-out"
                  onClick={() => onDeleteSavedInvoice(invoice.id)}
                >
                  <svg xmlns="http://www.w3.org/2d/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Controls;